
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member/register",
      function () {
        return require("private-next-pages/member/register.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/member/register"])
      });
    }
  